import React from 'react'
import clsx from 'clsx'
import { styled } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

import Paper from '@mui/material/Paper'

import { FCClassContext, cardSx, classToFComponent } from 'src/utils/views'
import { ScoreCardScope } from '../ta_scopes'

const TileContainer = styled(Paper)({
    ...cardSx,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '13px 14px',
    minWidth: 0,
    flexGrow: 1
})

const useStyles = makeStyles()({
    value: {
        display: 'flex',
        alignItems: 'baseline',
        gap: 4,
        fontSize: 'clamp(19px, 1.6vw, 26px)',
        lineHeight: 1,
        fontWeight: 800,
        color: 'var(--ink)',
        marginBottom: 7,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    unit: {
        fontSize: '0.62em',
        fontWeight: 700,
        color: 'var(--muted)'
    },
    label: {
        fontSize: 11.5,
        lineHeight: 1.25,
        color: 'var(--muted)',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }
})

export type ScoreViewProps = {
    className?: string
    scope: ScoreCardScope
}

class ScoreViewClass implements FCClassContext<ScoreViewProps> {
    // :: Methods

    render({ className, scope }: ScoreViewProps) {
        const classes = useStyles().classes

        return (
            <TileContainer className={clsx(className)} elevation={0}>
                <span className={classes.value} title={`${scope.value} ${scope.unit}`.trim()}>
                    {scope.value}
                    {!!scope.unit && <span className={classes.unit}>{scope.unit}</span>}
                </span>
                <span className={classes.label} title={scope.label}>
                    {scope.label}
                </span>
            </TileContainer>
        )
    }
}
export const ScoreView = classToFComponent(ScoreViewClass, React)
export default ScoreView
